import React, { useEffect, useState } from 'react'
import Layout from './layout'
import Subpages from './public/subpages'
import useMediaQuery from '../hooks/useMediaQuery'
import { Link, useParams } from 'react-router-dom'
import { BASE_URL, getNewList } from '../api/api'
import Pagination from './pagination'
import NavLink from './navLink'

const Ljhd = () => {
  const isMobile = useMediaQuery()
  const { channel_id = 1, page = 1 } = useParams()
  const pagesize = 20

  const [data, setData] = useState([])

  useEffect(() => {
    getNewList(
      `archives/newsList?pagesize=${pagesize}&channel_id=${channel_id}&page=${page}`.replace(
        '.html',
        ''
      )
    ).then(res => {
      setData(res?.data)
    })
  }, [pagesize, channel_id, page])

  return (
    <Layout>
      <Subpages className="px-5 lg:px-0 mb-10 lg:mb-0" name="历届活动">
        <div className="flex flex-col lg:flex-row justify-between flex-wrap">
          {data?.list?.data?.map(({ title, image = '', id, year, isnew }, key) => (
            <a
              target="_blank"
              href={`${isnew == 1 ? `/?ljhdid=${year}` : `/ljList/channel_id/${48}?year=${year}`}`}
              key={id}
              className="max-w-[273px]"
              rel="noreferrer"
            >
              <img
                className="mt-[30px]"
                src={`${BASE_URL}${image}`}
                style={{ width: isMobile ? '100%' : 273, height: 180 }}
                alt=""
              />
              <p className="text-left mt-4 font-sourceHan text-[#333333]">{title}</p>
            </a>
          ))}
          <div className="w-[273px]"></div>
          <div className="w-[273px]"></div>
        </div>
        <Pagination
          count={data?.list?.total}
          pagesize={pagesize}
          page={data?.list?.current_page}
          totalPage={data?.list?.last_page}
        />
      </Subpages>
    </Layout>
  )
}

export default Ljhd
